import { render, staticRenderFns } from "./formulaMedicaComponent.vue?vue&type=template&id=28d42584&scoped=true"
import script from "./formulaMedicaComponent.vue?vue&type=script&lang=js"
export * from "./formulaMedicaComponent.vue?vue&type=script&lang=js"
import style0 from "./formulaMedicaComponent.vue?vue&type=style&index=0&id=28d42584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d42584",
  null
  
)

export default component.exports